import request from "./serve";
import { MAXSIZE } from "@/common/constant/constant.js";

/**
 * 接口根据分页递归请求
 * @param {*} callback 每次请求的回调函数
 * @param {*} method
 * @param {*} url
 * @param {*} data
 * @param {*} loading
 * @returns
 */
export default async function recursionServe(
  callback,
  method,
  url,
  data,
  loading = true
) {
  const requestData = JSON.parse(JSON.stringify(data));
  requestData.page = 1;
  requestData.size = MAXSIZE || 1000;

  // 串行请求：先发起第一次请求获取总数
  try {
    const resultList = [];
    const firstRes = await request(method, url, requestData, loading);
    callback && callback(firstRes);
    resultList.push(firstRes);

    const total = firstRes.data?.total || 0;

    // 如果没有数据或只有一页，直接返回
    if (total <= requestData.size) {
      return resultList;
    }

    // 计算剩余需要请求的页数
    const totalPages = Math.ceil(total / requestData.size);

    // 从第二页开始串行请求，每次请求完成后才发起下一个
    for (let page = 2; page <= totalPages; page++) {
      const pageData = {
        ...requestData,
        page,
      };

      const res = await request(method, url, pageData, loading);
      callback && callback(res);
      resultList.push(res);
    }

    return resultList;
  } catch (error) {
    console.error("递归请求失败:", error);
    throw error;
  }
}
